import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FiltreAffaireComponent } from './filtre-affaire/filtre-affaire.component';
import { FiltreEcheancierComponent } from './filtre-echeancier/filtre-echeancier.component';
import { FilterEcheanceEcheanceComponent } from './filter-echeance-echeance/filter-echeance-echeance.component';
import { TranslateModule } from '@ngx-translate/core';
import { AngularMaterialModule } from 'src/app/angular-material/angular-material.module';

@NgModule({
    declarations: [
      
        FiltreAffaireComponent,
        FiltreEcheancierComponent,
        FilterEcheanceEcheanceComponent
    ],
    imports: [
        CommonModule,
        AngularMaterialModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        
    ],
    exports: [
      
        FiltreAffaireComponent,
        FiltreEcheancierComponent,
        FilterEcheanceEcheanceComponent
    ]
})
export class FilterEcheanceModule { }